<template>
  <div class="Rule">
    <r_header></r_header>

    <side_bar :links="links"></side_bar>
    <div class="markdown">
      <div class="md">
        <vue_markdown :source="rule"></vue_markdown>
      </div>
      <!-- <my_button :value="'下载规则'" @click.native="download" :inputStyle="buttonStyle"></my_button> -->
    </div>
  </div>
</template>

<script>
 // @ is an alias to /src

 import SideBar from '@/components/SideBar.vue';
 import RHeader from '@/components/frontpage/Header.vue';
 import MyButton from '@/components/Button.vue';
 import VueMarkdown from 'vue-markdown'
 

 export default {
   name: 'Rule',
   computed: {
     links () {
       return this.$store.state.sbar.linksRule
     },
     buttonStyle() {
       return {
         width: '62.5vw'
       }
     }
   },
   data () {
     return {
       rule: ''
     }
   },
   mounted() {
       this.$http.get('/oss/markdown/rule2026.md')
           .then(res => {
             this.rule = res.data
       })
   },
   methods: {
     download() {
       window.open('/oss/pdf/AI%E4%B8%96%E9%9D%92%E8%B5%9B2022%E8%B5%9B%E5%88%B6%E8%A7%84%E5%88%99.pdf',
        '_blank')
     }
   },

   components: {
     my_button: MyButton,
     r_header: RHeader,
     side_bar: SideBar,
     vue_markdown: VueMarkdown
   }
 }
</script>

<style scoped>
 .markdown{
   margin-top: 5.2vw;
   margin-bottom: 5.2vw;
   display: flex;
   flex-direction: column;
   align-items:center;
   justify-content: center;
 }
 .md{
   width: 62.5vw;
   text-align: left;
   background-color: #22277c;
   color: white;
   box-sizing: border-box;
   padding: 3.125vw 2.6vw 1vw 2.6vw;
   line-height: 1.875vw;
 }

@media (min-width: 320px) and (max-width: 480px) {
  .md{
    width: 100vw;
   line-height: normal;
  }
 }

</style>
<style>
 .md a{
   color: #FFBA84 !important;
 }
</style>
